import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Shifts from "./pages/Shifts";
import Waiver from "./pages/Waiver";
import Admin from "./pages/Admin";
import Handbook from "./pages/Handbook";
import Profile from "./pages/Profile";
import Welcome from "./pages/Welcome";
import ConfirmEmail from "./pages/ConfirmEmail";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/Footer";

const NO_FOOTER = ["/login", "/register", "/forgot-password", "/reset-password", "/auth/callback", "/confirm-email", "/welcome"];

function AppRouter() {
  const location = useLocation();
  // Google OAuth callback — detect session_id in URL fragment before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const showFooter = !NO_FOOTER.includes(location.pathname);
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/handbook" element={<Handbook />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/welcome" element={<ProtectedRoute><Welcome /></ProtectedRoute>} />
        <Route path="/shifts" element={<ProtectedRoute><Shifts /></ProtectedRoute>} />
        <Route path="/waiver" element={<ProtectedRoute><Waiver /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="*" element={<Landing />} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
